import React from 'react';
import ImageWithFallback from './ImageWithFallback';
import './App.css';

const Robot = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Robot Drawing</h1>
        <p>Create a cool robot with this futuristic coding project.</p>
        <div
          style={{
            width: "100%",
            maxWidth: "400px",
            height: "300px",
            borderRadius: "18px",
            marginBottom: "18px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 24px auto",
          }}
        >
          <ImageWithFallback 
            src="/robot.gif" 
            alt="Robot Drawing" 
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "18px",
            }}
          />
        </div>
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project draws a futuristic robot using Python code and turtle graphics.</p>
        <h2>Download</h2>
        <a href="/robot.py" download>Download robot.py</a>
        <h2>How to Run</h2>
        <p>Run the Python file in your local environment to see the robot being drawn.</p>
      </div>
    </div>
  );
};

export default Robot;
